import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, Subject, Subscription, concat } from 'rxjs';
import {
  distinctUntilChanged,
  switchMap,
  catchError,
  tap,
  map,
  debounceTime,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';
import { ClientPurchaseOrderService } from '@app/core/client/services/client-purchase-order.service';
import { ClientUsersService } from '@app/core/client/services/client-users.service';
import { ClientService } from '@app/core/client/services/client.service';
import { FactoryService } from '@app/core/factories';
import { KitService } from '@app/core/kits/services/kit.service';
import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';
import { PoService } from '@app/core/purchase-orders/services/po.service';
import { RfqService } from '@app/core/quotes';
import { ProductDesignService } from '@app/core/quotes/services/product-design.service';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { environment } from '@app/env-service';
import { ClientPurchaseOrderPopupFormComponent } from '@app/modules/clients/client-purchase-order-popup-form/client-purchase-order-popup-form.component';
import { PopupFormComponent as ClientUserPopupForm } from '@app/modules/clients/popup-form/popup-form.component';
import { AuthFormModalComponent as FactoryModalComponent } from '@app/modules/factories/form-modal/form-modal.component';
import { ClientFormComponent } from '@app/shared/components/client-form/client-form.component';
import { PurchaseOrderFormComponent } from '@app/shared/components/purchase-orders/purchase-order-form/purchase-order-form.component';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

import { CreateClientRfqComponent } from '../../create-client-rfq/create-client-rfq.component';
import { NdAttachmentPopupComponent } from '../nd-attachment-popup/nd-attachment-popup.component';
import { NdPopupFormComponent } from '../nd-popup-form/nd-popup-form.component';

@Component({
  selector: 'cnc-nd-view-card-popup',
  templateUrl: './nd-view-card-popup.component.html',
  styleUrls: ['./nd-view-card-popup.component.scss'],
})
export class NdViewCardPopupComponent implements OnInit {
  // sku
  rfq$ :Observable<any[]>;
  rfqLoading = false;
  rfqInput$ = new Subject<string>();
  rfqProduct :any;

  // kits
  kit$ :Observable<any[]>;
  kitLoading = false;
  kitInput$ = new Subject<string>();

  // clients
  client$ :Observable<any[]>;
  clientLoading = false;
  clientInput$ = new Subject<string>();

  // po
  purchaseOrder$ :Observable<any[]>;
  purchaseOrderLoading = false;
  purchaseOrderInput$ = new Subject<string>();

  // client po
  clientPo$ :Observable<any[]>;
  clientPoLoading = false;
  clientPoInput$ = new Subject<string>();

  // client user
  clientUser$ :Observable<any[]>;
  clientUserLoading = false;
  clientUserInput$ = new Subject<string>();

  // factories
  factory$ :Observable<any[]>;
  factoryLoading = false;
  factoryInput$ = new Subject<string>();

  selected :any = {
    kits: null,
    rfqs: null,
    clients: null,
    purchase_orders: null,
    client_purchase_orders: null,
    client_users: null,
  };

  subscription :Subscription;
  // design: any;

  showLinks :boolean = false;

  priority :any = {
    '10': 'Low',
    '20': 'Medium',
    '30': 'High',
  };

  isImporting :boolean = false;

  subtask_form_handler :any = [];
  comment_form_handler :any = [];

  comment_handler :any = {
    id: null,
    body: '',
    editable: false,
    filestoupload: [],
  };

  tabIndex :number = 0;

  activeDescriptionTab :number = 0;

  @Input() designCard :any;
  designEdited :boolean = false;
  design :any;

  mappedTags :any;
  staticTags :any;
  staticTagIds :any = [];

  highlightSubtaskId :any;

  saveTemplateEventSubject :Subject<void> = new Subject<void>();
  overwriteTemplateEventSubject :Subject<void> = new Subject<void>();

  constructor(
    private productDesignSvc :ProductDesignService,
    private activeRoute :ActivatedRoute,
    private cd :ChangeDetectorRef,
    private modal :NgbModal,
    public activeModal :NgbActiveModal,
    private translate :TranslateService,
    private toastr :ToastrService,
    public router :Router,
    public authService :AuthService,
    private rfqSvc :RfqService,
    private kitSvc :KitService,
    private clientSvc :ClientService,
    private poService :PoService,
    private clientPoService :ClientPurchaseOrderService,
    private clientUserService :ClientUsersService,
    private factoryService :FactoryService,
    public settingsSvc :SettingsService,
    private tagSvc :ProductTagService,
    private ft :FeatureToggleService,
  ) {}

  ngOnInit() {
    this.activeRoute.queryParams.subscribe((params) => {
      this.tabIndex = params.tab;
      this.highlightSubtaskId = params.subtaskId;
    });

    this.loadConfigs();

    this.getStaticTags();

    this.productDesignSvc.getById(this.designCard.id).subscribe((resp) => {
      if (resp && resp.id) {
        this.design = resp;

        this.setStaticTags();

        this.design.assigned_subtasks.map((obj) => ({
          ...obj,
          editable: false,
        }));
        this.subtask_form_handler = JSON.parse(
          JSON.stringify(this.design.assigned_subtasks),
        );

        this.design.assigned_comments.map((obj) => ({
          ...obj,
          editable: false,
        }));
        this.comment_form_handler = JSON.parse(
          JSON.stringify(this.design.assigned_comments),
        );

        // this.mappedTags = this.mapAssignedTags(this.design.assigned_tags);
        let tagsList = [];
        this.design.assigned_tags.forEach((tag) => {
          tagsList = tagsList.concat(this.tagSvc.pushTags(tag.tag, []));
        });

        this.mappedTags = this.tagSvc.formatTagHierarchyList(
          this.tagSvc.getUniqueByKey(tagsList, 'id'),
        );
      }
      this.cd.detectChanges();
    });
  }

  setStaticTags() {
    this.staticTags = [];
    if (
      this.design &&
      this.design.static_tags &&
      this.staticTagIds &&
      this.staticTagIds.length > 0
    ) {
      let tagsList = [];

      this.staticTagIds.forEach((tagId) => {
        const tags = this.design.static_tags.filter(
          (row) => row.static_tag_id == tagId,
        );
        if (tags && tags.length > 0) {
          tags.forEach((tag) => {
            tagsList = tagsList.concat(this.tagSvc.pushTags(tag.tag, []));
            tagsList = tagsList.concat(this.tagSvc.pushTags(tag.static_tag, []));
          });
        }
      });
      this.staticTags = this.tagSvc.formatTagHierarchyList(
        this.tagSvc.getUniqueByKey(tagsList, 'id'),
      );
    }
  }

  getStaticTags() {
    this.settingsSvc.getProjectManagementSettings().subscribe((resp :any) => {
      if (resp && resp.id) {
        this.staticTagIds = [];
        const settings = JSON.parse(resp.value);
        if (settings.static_tag_ids && settings.static_tag_ids.length > 0) {
          // staticTags
          this.staticTagIds = settings.static_tag_ids;
        }
        this.setStaticTags();
      }
    });
  }

  private loadConfigs() {
    this.client$ = concat(
      of([]), // default items
      this.clientInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.clientLoading = true)),
        switchMap((term) =>
          this.clientSvc.search(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.clientLoading = false)),
          ),
        ),
      ),
    );

    this.purchaseOrder$ = concat(
      of([]), // default items
      this.purchaseOrderInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.purchaseOrderLoading = true)),
        switchMap((term) =>
          this.poService.search({ po_number: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.purchaseOrderLoading = false)),
          ),
        ),
      ),
    );

    this.clientPo$ = concat(
      of([]), // default items
      this.clientPoInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.clientPoLoading = true)),
        switchMap((term) =>
          this.clientPoService.search({ id: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.clientPoLoading = false)),
          ),
        ),
      ),
    );

    this.clientUser$ = concat(
      of([]), // default items
      this.clientUserInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.clientUserLoading = true)),
        switchMap((term) =>
          this.clientUserService.search({ keyword: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.clientUserLoading = false)),
          ),
        ),
      ),
    );

    this.factory$ = concat(
      of([]), // default items
      this.factoryInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.factoryLoading = true)),
        switchMap((term) =>
          this.factoryService.search({ keyword: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.factoryLoading = false)),
          ),
        ),
      ),
    );
  }

  mapAssignedTags(tags :any) {
    const list = [];
    let tag = [];
    // // loop until no children
    function traverse(item) {
      tag.push(item.name);
      if (item.assigned_parent) {
        traverse(item.assigned_parent);
      } else {
        list.push(tag.reverse());
        tag = [];
      }
    }

    tags.forEach((element) => {
      if (element.tag.assigned_parent) {
        traverse(element.tag);
      } else {
        list.push([element.tag.name]);
      }
    });

    return list;
  }

  viewAttachment(attachment) {
    // this.router.navigateByUrl('/quotes/new-designs/' + design.id.toString() + '/update');
    const modalRef = this.modal.open(NdAttachmentPopupComponent, {
      windowClass: 'myCustomModalClass',
    });
    modalRef.componentInstance.attachment = attachment;
  }

  closeModal() {
    this.activeModal.close(this.designEdited);
    this.router.navigateByUrl('/inventory/new-designs');
  }

  editdesign() {
    const modalRef = this.modal.open(NdPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.design = this.design;
    modalRef.result.then(
      (newDesign :any) => {
        this.design = newDesign;
        this.designCard = newDesign;
        this.designEdited = this.design;

        let tagsList = [];
        this.design.assigned_tags.forEach((tag) => {
          tagsList = tagsList.concat(this.tagSvc.pushTags(tag.tag, []));
        });

        this.mappedTags = this.tagSvc.formatTagHierarchyList(
          this.tagSvc.getUniqueByKey(tagsList, 'id'),
        );
        this.setStaticTags();

        this.cd.detectChanges();
      },
      (_) => {},
    );
  }

  cancelSubtaskItem() {
    this.design.assigned_subtasks.map((subtask, i) => {
      this.design.assigned_subtasks[i].editable = false;
    });

    this.design.assigned_subtasks.map((subtask, i) => {
      if (
        this.subtask_form_handler[i].text == null ||
        this.subtask_form_handler[i].text == ''
      ) {
        //new
        this.design.assigned_subtasks.splice(i, 1);
      } else {
        //existing
        this.design.assigned_subtasks[i].text = this.subtask_form_handler[i].text;
      }
    });

    this.subtask_form_handler = JSON.parse(
      JSON.stringify(this.design.assigned_subtasks),
    );
  }

  addSubtaskItem() {
    this.design.assigned_subtasks = JSON.parse(
      JSON.stringify(this.subtask_form_handler),
    );
    this.cancelSubtaskItem();

    const item = {
      id: null,
      text: '',
      editable: true,
      done: false,
    };
    this.design.assigned_subtasks.push(item);
    this.subtask_form_handler = JSON.parse(
      JSON.stringify(this.design.assigned_subtasks),
    );
  }

  editSubtaskItem(index) {
    this.cancelSubtaskItem();
    this.design.assigned_subtasks[index].editable = true;
  }

  saveSubtaskItem(index) {
    if (
      this.design.assigned_subtasks[index].text == null ||
      this.design.assigned_subtasks[index].text == ''
    ) {
      this.design.assigned_subtasks.splice(index, 1);
    } else {
      this.design.assigned_subtasks[index].editable = false;
    }
    this.subtask_form_handler = JSON.parse(
      JSON.stringify(this.design.assigned_subtasks),
    );

    const data = {
      text: this.design.assigned_subtasks[index].text,
      done: this.design.assigned_subtasks[index].done,
      id: null,
    };

    if (this.design.assigned_subtasks[index].id != null) {
      data.id = this.design.assigned_subtasks[index].id;
    }

    this.productDesignSvc.saveSubtask(this.design.id, data).subscribe(
      (resp) => {
        if (resp && resp.id) {
          this.design = resp;

          this.design.assigned_subtasks.map((obj) => ({
            ...obj,
            editable: false,
          }));
          this.subtask_form_handler = JSON.parse(
            JSON.stringify(this.design.assigned_subtasks),
          );

          this.design.assigned_comments.map((obj) => ({
            ...obj,
            editable: false,
          }));
          this.comment_form_handler = JSON.parse(
            JSON.stringify(this.design.assigned_comments),
          );
        }
        this.cd.detectChanges();
      },
      (err) => {},
    );
  }

  deleteSubtaskItem(index) {
    const data = {
      text: this.design.assigned_subtasks[index].text,
      done: this.design.assigned_subtasks[index].done,
      id: this.design.assigned_subtasks[index].id,
    };

    this.design.assigned_subtasks.splice(index, 1);
    this.subtask_form_handler = JSON.parse(
      JSON.stringify(this.design.assigned_subtasks),
    );

    if (data.id != null) {
      this.productDesignSvc.deleteSubtask(this.design.id, data).subscribe(
        (resp) => {
          if (resp && resp.id) {
            this.design = resp;
            this.design.assigned_subtasks.map((obj) => ({
              ...obj,
              editable: false,
            }));
            this.subtask_form_handler = JSON.parse(
              JSON.stringify(this.design.assigned_subtasks),
            );

            this.design.assigned_comments.map((obj) => ({
              ...obj,
              editable: false,
            }));
            this.comment_form_handler = JSON.parse(
              JSON.stringify(this.design.assigned_comments),
            );
          }
          this.cd.detectChanges();
        },
        (err) => {},
      );
    }
  }

  toggleCheckbox(index, event) {
    this.cancelSubtaskItem();
    const data = {
      text: this.design.assigned_subtasks[index].text,
      done: this.design.assigned_subtasks[index].done,
      id: this.design.assigned_subtasks[index].id,
    };
    if (data.id != null) {
      this.productDesignSvc.toggleCheckSubtask(this.design.id, data).subscribe(
        (resp) => {
          if (resp && resp.id) {
            this.design = resp;
            this.design.assigned_subtasks.map((obj) => ({
              ...obj,
              editable: false,
            }));
            this.subtask_form_handler = JSON.parse(
              JSON.stringify(this.design.assigned_subtasks),
            );
          }
          this.cd.detectChanges();
        },
        (err) => {},
      );
    }
  }

  deletedesign() {
    Swal.fire({
      title: 'Confirm delete?',
      text: "Delete design '" + this.design.design_name + "'?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        this.productDesignSvc
          .deleteproductDesign(this.design.id)
          .subscribe((resp :any) => {
            this.router.navigate(['/quotes', 'new-designs']);
            // console.log(resp);
            this.toastr.success('Successfully deleted design.', 'Success');
            this.activeModal.close({
              method: 'delete',
              design: this.design,
            });
          });
      }
    });
  }

  cancelCommentItem() {
    this.design.assigned_comments.map((comment, i) => {
      this.design.assigned_comments[i].editable = false;
    });

    this.design.assigned_comments.map((comment, i) => {
      if (
        this.comment_form_handler[i].body == null ||
        this.comment_form_handler[i].body == ''
      ) {
        //new
        this.design.assigned_comments.splice(i, 1);
      } else {
        //existing
        this.design.assigned_comments[i].body = this.comment_form_handler[i].body;
      }
    });

    this.comment_form_handler = JSON.parse(
      JSON.stringify(this.design.assigned_comments),
    );
  }

  editCommentItem(index) {
    this.cancelCommentItem();
    this.design.assigned_comments[index].editable = true;
  }

  saveComment() {
    this.isImporting = true;

    const fd = new FormData();
    fd.append('body', this.comment_handler.body);
    fd.append('id', '');

    this.comment_handler.filestoupload.forEach((file) => {
      fd.append('file[]', file.file);
    });

    this.productDesignSvc.saveComment(this.design.id, fd).subscribe(
      (resp) => {
        if (resp && resp.id) {
          this.design = resp;

          this.design.assigned_comments.map((obj) => ({
            ...obj,
            editable: false,
          }));
          this.comment_form_handler = JSON.parse(
            JSON.stringify(this.design.assigned_comments),
          );

          this.design.assigned_subtasks.map((obj) => ({
            ...obj,
            editable: false,
          }));
          this.subtask_form_handler = JSON.parse(
            JSON.stringify(this.design.assigned_subtasks),
          );

          this.comment_handler = {
            id: null,
            body: '',
            editable: false,
            filestoupload: [],
          };

          this.isImporting = false;
        }
        this.cd.detectChanges();
      },
      (err) => {
        this.isImporting = false;
      },
    );
  }

  clearComment() {
    this.comment_handler = {
      id: null,
      body: '',
      editable: false,
    };
  }

  deleteCommentItem(index) {
    Swal.fire({
      title: 'Confirm delete?',
      text: 'Delete comment ?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        const data = {
          body: this.design.assigned_comments[index].body,
          id: this.design.assigned_comments[index].id,
        };

        this.design.assigned_comments.splice(index, 1);
        this.comment_form_handler = JSON.parse(
          JSON.stringify(this.design.assigned_comments),
        );

        if (data.id != null) {
          this.productDesignSvc.deleteComment(this.design.id, data).subscribe(
            (resp) => {
              if (resp && resp.id) {
                this.design = resp;

                this.design.assigned_comments.map((obj) => ({
                  ...obj,
                  editable: false,
                }));
                this.comment_form_handler = JSON.parse(
                  JSON.stringify(this.design.assigned_comments),
                );

                this.design.assigned_subtasks.map((obj) => ({
                  ...obj,
                  editable: false,
                }));
                this.subtask_form_handler = JSON.parse(
                  JSON.stringify(this.design.assigned_subtasks),
                );

                this.toastr.success('Successfully deleted comment.', 'Success');
              }
              this.cd.detectChanges();
            },
            (err) => {},
          );
        }
      }
    });
  }

  saveCommentItem(index) {
    this.isImporting = true;

    const fd = new FormData();
    fd.append('body', this.design.assigned_comments[index].body);
    fd.append('id', this.design.assigned_comments[index].id || null);

    this.design.assigned_comments[index].filestoupload.forEach((file) => {
      fd.append('file[]', file.file);
    });

    this.productDesignSvc.saveComment(this.design.id, fd).subscribe(
      (resp) => {
        if (resp && resp.id) {
          this.design = resp;

          this.design.assigned_comments.map((obj) => ({
            ...obj,
            editable: false,
          }));
          this.comment_form_handler = JSON.parse(
            JSON.stringify(this.design.assigned_comments),
          );

          this.design.assigned_subtasks.map((obj) => ({
            ...obj,
            editable: false,
          }));
          this.subtask_form_handler = JSON.parse(
            JSON.stringify(this.design.assigned_subtasks),
          );

          this.isImporting = false;
        }
        this.cd.detectChanges();
      },
      (err) => {
        this.isImporting = false;
      },
    );
  }

  handleFileInputItem(event :any, i) {
    const files = Array.prototype.slice.call(event.target.files);
    const kani = this;
    let maxSizeError = false;

    files.forEach((file, idx) => {
      if (file.size > 26214400) {
        maxSizeError = true;
      } else {
        const ftu :any = {
          previewSrc: '',
          file: file,
        };
        this.design.assigned_comments[i].filestoupload.push(ftu);
        if (file.type.toString().search('image') >= 0) {
          const index = this.design.assigned_comments[i].filestoupload.length - 1;
          const fReader = new FileReader();
          fReader.readAsDataURL(file);
          fReader.onload = function (e :any) {
            kani.design.assigned_comments[i].filestoupload[index].previewSrc =
              e.target.result;
          };
        }
      }
    });
    if (maxSizeError) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });
    }
    event.target.value = '';
  }

  handleFileInput(event :any) {
    const files = Array.prototype.slice.call(event.target.files);
    const kani = this;
    let maxSizeError = false;

    files.forEach((file, idx) => {
      if (file.size > 26214400) {
        maxSizeError = true;
      } else {
        const ftu :any = {
          previewSrc: '',
          file: file,
        };
        this.comment_handler.filestoupload.push(ftu);
        if (file.type.toString().search('image') >= 0) {
          const index = this.comment_handler.filestoupload.length - 1;
          const fReader = new FileReader();
          fReader.readAsDataURL(file);
          fReader.onload = function (e :any) {
            kani.comment_handler.filestoupload[index].previewSrc = e.target.result;
          };
        }
      }
    });
    if (maxSizeError) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });
    }
    event.target.value = '';
  }

  viewAttachmentComment(attachment) {
    const modalRef = this.modal.open(NdAttachmentPopupComponent, {
      windowClass: 'myCustomModalClass',
    });
    const data = {
      url: attachment.url,
      type: attachment.filetype,
      name: attachment.filename,
    };
    modalRef.componentInstance.attachment = data;
  }

  deleteAttachment(index_comment, index_attachment) {
    Swal.fire({
      title: 'Confirm delete?',
      text: 'Delete attachment ?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        const data = {
          id: this.design.assigned_comments[index_comment].assigned_attachments[
            index_attachment
          ].id,
        };

        this.design.assigned_comments[index_comment].assigned_attachments.splice(
          index_attachment,
          1,
        );
        this.comment_form_handler = JSON.parse(
          JSON.stringify(this.design.assigned_comments),
        );

        if (data.id != null) {
          this.productDesignSvc.deleteAttachment(this.design.id, data).subscribe(
            (resp) => {
              if (resp && resp.id) {
                this.design = resp;

                this.design.assigned_comments.map((obj) => ({
                  ...obj,
                  editable: false,
                }));
                this.design.assigned_comments[index_comment].editable = true;

                this.comment_form_handler = JSON.parse(
                  JSON.stringify(this.design.assigned_comments),
                );

                this.design.assigned_subtasks.map((obj) => ({
                  ...obj,
                  editable: false,
                }));
                this.subtask_form_handler = JSON.parse(
                  JSON.stringify(this.design.assigned_subtasks),
                );

                this.toastr.success('Successfully deleted attachment.', 'Success');
              }
              this.cd.detectChanges();
            },
            (err) => {},
          );
        }
      }
    });
  }

  updateSku(rfq :any, index :number) {
    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure to update selected sku as Inventory SKU?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
    }).then((result) => {
      if (result.value) {
        Swal.fire('', 'Updating, please wait...');
        Swal.showLoading();

        this.rfqSvc
          .updateProductType(rfq.id, {
            product_type_id: 2,
            product_type: 'Inventory',
          })
          .subscribe((resp :any) => {
            Swal.fire('Updated.', 'Updated successfully.');
            Swal.hideLoading();

            this.design.linked_rfqs[index] = {
              ...this.design.linked_rfqs[index],
              product_type_id: resp.product_type_id,
              product_type: resp.product_type,
            };

            this.cd.detectChanges();
          });
      }
    });
  }

  createAsSku() {
    const data :any = {
      product_name: this.design.design_name,
      product_description: this.design.description,
      product_type_id: 3,
      product_tags: this.design.assigned_tags
        ? JSON.stringify(this.design.assigned_tags.map((e) => e.tag_id))
        : [],
      product_links: this.design.links ? JSON.stringify(this.design.links) : [],
      design_id: this.design.id,
      product_category_id: 0,
    };

    Swal.fire({
      title: 'Are you sure to convert this card to RFQ?',
      text: "You'll lose all the modules that are linked in this card.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
    }).then((result) => {
      if (result.value) {
        Swal.showLoading();
        this.rfqSvc.createRfq(data).subscribe(
          (resp :any) => {
            this.design.is_quotation = 1;
            this.design.rfq = resp.record;
            this.design.rfq_id = resp.record.id;
            this.toastr.success('Successfully converted to RFQ.', 'Success');
            Swal.close();
            this.cd.detectChanges();
          },
          (errorResp :any) => {
            Swal.fire({
              title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
              text: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TEXT'),
              type: 'error',
              confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
            }).then((data) => {
              // this.loading = false;
              Swal.close();
              this.cd.markForCheck();
            });
          },
        );
      }
    });
  }

  updateQuotation(data :any) {
    // console.log("emit", data);
  }

  private getSelectedSKUItem(data :any) :void {
    this.selected.rfqs = data;
  }

  private getSelectedKitItem(data :any) :void {
    this.selected.kits = data;
  }

  createRfq(rfq ?:any, index ?:number) {
    const modalRef = this.modal.open(CreateClientRfqComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    if (rfq) {
      modalRef.componentInstance.rfq = rfq;
    } else {
      modalRef.componentInstance.product_type = 1;
    }

    modalRef.result.then(
      (resp :any) => {
        if (rfq) {
          this.design.linked_rfqs[index] = {
            ...resp,
            pivot: this.design.linked_rfqs[index].pivot,
          };
        } else {
          if (resp && resp.id) {
            this.design.linked_rfqs = [
              ...this.design.linked_rfqs,
              {
                id: resp.id,
                product_name: resp.product_name,
                internal_sku: resp.internal_sku,
                pivot: { remarks: '' },
              },
            ];

            this.addToModule('rfqs', true);
          }
        }
        this.cd.detectChanges();
      },
      (_) => {},
    );
  }

  createClient() {
    const modalRef = this.modal.open(ClientFormComponent, {
      size: 'lg',
    });
    modalRef.result.then(
      (resp :any) => {
        // console.log(resp);
        if (resp && resp.id) {
          this.design.linked_clients = [
            ...this.design.linked_clients,
            {
              id: resp.id,
              business_name: resp.business_name,
              user: resp.user
                ? {
                    id: resp.user.id,
                    firstname: resp.user.firstname,
                    lastname: resp.user.lastname,
                  }
                : null,
              pivot: { remarks: '' },
            },
          ];

          this.addToModule('clients', true);
          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createPurchaseOrder() {
    const modalRef = this.modal.open(PurchaseOrderFormComponent, {
      size: 'lg',
      windowClass: 'po-form-modal',
    });

    modalRef.result.then(
      (resp :any) => {
        // console.log(resp);
        if (resp && resp.id) {
          this.design.linked_purchase_orders = [
            ...this.design.linked_purchase_orders,
            {
              ...resp,
              pivot: { remarks: '' },
            },
          ];

          this.addToModule('purchase_orders', true);
          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createClientPO() {
    const modalRef = this.modal.open(ClientPurchaseOrderPopupFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.result.then(
      (resp :any) => {
        if (resp && resp.id) {
          this.design.linked_client_purchase_orders = [
            ...this.design.linked_client_purchase_orders,
            {
              id: resp.id,
              order_date: resp.order_date,
              pivot: { remarks: '' },
            },
          ];

          this.addToModule('client_purchase_orders', true);
          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createClientUser() {
    const modalRef = this.modal.open(ClientUserPopupForm, {
      size: 'lg',
    });
    modalRef.result.then(
      (resp :any) => {
        if (resp && resp.id) {
          this.design.linked_client_users = [
            ...this.design.linked_client_users,
            {
              id: resp.id,
              firstname: resp.firstname,
              lastname: resp.lastname,
              email: resp.email,
              pivot: { remarks: '' },
            },
          ];

          this.addToModule('client_users', true);
          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createFactory() {
    const modalRef = this.modal.open(FactoryModalComponent, {
      size: 'lg',
    });

    modalRef.result.then(
      (resp :any) => {
        if (resp && resp.id) {
          this.design.linked_factories = [
            ...this.design.linked_factories,
            {
              id: resp.id,
              factory_name: resp.factory_name,
              pivot: { remarks: '' },
            },
          ];

          this.addToModule('factories', true);
          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  addToModule(module :string, isNewRecord ?:boolean) {
    if (!this.selected[module] && !isNewRecord) return;

    const exist = isNewRecord
      ? false
      : this.design['linked_' + module].some(
          (el) => el.id === this.selected[module].id,
        );
    if (exist && !isNewRecord) {
      this.toastr.error('Record already added.');

      return;
    }

    let linked_data = JSON.parse(JSON.stringify(this.design['linked_' + module])); // deep cop
    if (!isNewRecord)
      linked_data.push({ ...this.selected[module], pivot: { remarks: '' } });
    linked_data = linked_data.reduce((acc, curr) => {
      return { ...acc, [parseInt(curr.id)]: { remarks: curr.pivot.remarks } };
    }, []);

    this.productDesignSvc
      .updateLinkedModules(this.design.id, { [module]: linked_data })
      .subscribe(
        (resp) => {
          if (!isNewRecord) {
            this.design['linked_' + module] = [
              ...this.design['linked_' + module],
              { ...this.selected[module], pivot: { remarks: '' } }, // for remarks
            ];
          }

          this.design.linked_resources_count += 1;

          this.selected[module] = null;
          this.toastr.success('Added successfully.');
          this.cd.detectChanges();
        },
        (err) => {
          console.log(err);
          this.toastr.error(
            'Error adding record. Try again later or contact support.',
          );
          this.cd.detectChanges();
        },
      );
  }

  removeFromModule(module :string, idx :number) {
    const copy = JSON.parse(JSON.stringify(this.design['linked_' + module]));
    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure to remove this record?.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
    }).then((result) => {
      if (result.value) {
        const payload = [
          ...this.design['linked_' + module].slice(0, idx),
          ...this.design['linked_' + module].slice(idx + 1),
        ].reduce((acc, curr) => {
          return {
            ...acc,
            [parseInt(curr.id)]: { remarks: curr.pivot.remarks },
          };
        }, []);

        this.design['linked_' + module].splice(idx, 1);

        this.productDesignSvc
          .updateLinkedModules(this.design.id, { [module]: payload })
          .subscribe(
            (resp) => {
              this.design.linked_resources_count -= 1;
              this.toastr.success('Removed successfully.');
              this.cd.detectChanges();
            },
            (err) => {
              // console.log(err);
              this.design['linked_' + module] = [...copy];
              this.toastr.error(
                'Error removing record. Try again later or contact support.',
              );
              this.cd.detectChanges();
            },
          );
      }
    });
  }

  convertToRFQ() {
    const data :any = {
      product_name: this.design.design_name,
      product_description: this.design.description,
      product_type_id: 3,
      product_tags: this.design.assigned_tags
        ? JSON.stringify(this.design.assigned_tags.map((e) => e.tag_id))
        : [],
      product_links: this.design.links ? JSON.stringify(this.design.links) : [],
      design_id: this.design.id,
      product_category_id: 0,
    };

    Swal.fire({
      title: 'Are you sure to convert this card to RFQ?',
      text: "You'll lose all the modules that are linked in this card.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
    }).then((result) => {
      if (result.value) {
        Swal.showLoading();
        this.rfqSvc.createRfq(data).subscribe(
          (resp :any) => {
            this.design.is_quotation = 1;
            this.design.rfq = resp.record;
            this.design.rfq_id = resp.record.id;
            this.toastr.success('Successfully converted to RFQ.', 'Success');
            Swal.close();
            this.cd.detectChanges();
          },
          (errorResp :any) => {
            Swal.fire({
              title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
              text: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TEXT'),
              type: 'error',
              confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
            }).then((data) => {
              // this.loading = false;
              Swal.close();
              this.cd.markForCheck();
            });
          },
        );
      }
    });
  }

  convertToInventory() {
    Swal.fire({
      title: 'Convert to Inventory SKU',
      text: 'Are you sure to convert this to Inventory SKU?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
    }).then((result) => {
      if (result.value) {
        Swal.showLoading();
        const product_type_id = 2;
        const product_type = this.settingsSvc.productTypes.find(
          (row) => row.id == product_type_id,
        ).text;
        this.rfqSvc
          .updateProductType(this.design.rfq.id, {
            product_type_id,
            product_type,
            design_id: this.design.id,
          })
          .subscribe((resp) => {
            this.design = {
              ...this.design,
              is_quotation: 0,
              rfq_id: resp.id,
              rfq: resp,
            };
            this.cd.detectChanges();
          });
      }
    });
  }

  emitSaveTemplateEvent() {
    this.saveTemplateEventSubject.next();
  }

  emitOverwriteTemplateEvent() {
    this.overwriteTemplateEventSubject.next();
  }

  calculateDueDays() {
    const currentDate = new Date();
    const dateCreated = new Date(this.design.created_at);

    const days = Math.floor(
      (Date.UTC(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
      ) -
        Date.UTC(
          dateCreated.getFullYear(),
          dateCreated.getMonth(),
          dateCreated.getDate(),
        )) /
        (1000 * 60 * 60 * 24),
    );

    return this.design.project_type.lead_time_days - days;
  }

  updateTabsCount(changes :any) {
    this.design[changes.key] = changes.value;
  }

  downloadAttachment(attachment :any) :void {
    const url :string =
      environment.urlV2.replace(/admin/g, 'shared') +
      '/files/download?path=' +
      attachment.filename;
    window.open(url, '_blank');
  }
}
